module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/price-config-inactive.db687f2d.svg";